import { useEffect, useState } from 'react';
// @mui
import {
  Box,
  Button,
  Card,
  Container,
  FormControlLabel,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Tooltip,
} from '@mui/material';
// routes
// import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import ConfirmDialogue from 'src/components/dialouge/ConfirmDialogue';
import { TABLE_HEAD_COLOR } from 'src/core';
import AxiosAll from 'src/services/axiosAll';
import useSettings from '../../hooks/useSettings';
import useTable from '../../hooks/useTable';
import useTabs from '../../hooks/useTabs';
// _mock_
// components
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { TableHeadCustom, TableNoData, TableSelectedActions, TableSkeleton } from '../../components/table';
// sections
import { TaskStatusTableRow, TaskStatusTableToolbar } from '../../sections/@dashboard/task_status/list';
import CreateTaskStatus from './Create';

// ----------------------------------------------------------------------

export default function TaskStatus() {
  const {
    dense,
    page,
    order,
    orderBy,
    rowsPerPage,
    setRowsPerPage,
    setPage,
    //
    selected,
    setSelected,
    onSelectRow,
    onSelectAllRows,
    //
    onSort,
    onChangeDense,
    onChangePage,
    onChangeRowsPerPage,
  } = useTable();

  const { themeStretch } = useSettings();

  // const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [filterRole, setFilterRole] = useState('all');
  const [currentStatus, setCurrentStatus] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [multipleDeleteMode, setMultipleDeleteMode] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userDetails } = useSelector((state) => state.loginReducer);
  const { token } = userDetails;

  const { enqueueSnackbar } = useSnackbar();

  const { currentTab: filterStatus, onChangeTab: onChangeFilterStatus } = useTabs('all');

  const handleFilterName = (filterName) => {
    setFilterName(filterName);
    setPage(0);
  };

  const handleFilterRole = (event) => {
    setFilterRole(event.target.value);
  };

  const handleDeleteRow = async (id) => {
    const response = await AxiosAll('delete', `/task-statuses/${id}`, {}, token);
    const { data } = response;
    if (data?.statusCode === 200) {
      enqueueSnackbar(data?.message, { variant: 'success' });
      if (selected.length > 0) {
        setSelected([]);
      }
      getAllStatus();
    } else {
      enqueueSnackbar(data?.message, { variant: 'error' });
    }
  };

  const handleDeleteRows = async (selected) => {
    const response = await AxiosAll('delete', `/task-statuses`, { ids: selected }, token);
    const { data } = response;
    if (data?.statusCode === 200) {
      enqueueSnackbar(data?.message, { variant: 'success' });
      setSelected([]);
      getAllStatus();
    } else {
      enqueueSnackbar(data?.message, { variant: 'error' });
    }
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    background: isDragging ? '#ebebeb' : 'white',
    ...draggableStyle,
  });

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const movedItems = reorder(tableData, result.source.index, result.destination.index);
    setTableData(movedItems);
  };

  // const getAllStatus = async () => {
  //   setLoading(true);
  //   const response = await AxiosAll('get', `/task-statuses?page=${page + 1}&query=${filterName}`, {}, token);
  //   const { data } = response;
  //   window.scrollTo(0, 0);

  //   if (data?.statusCode === 200) {
  //     setRowsPerPage(data?.data?.per_page);
  //     setTableData(data?.data?.data);
  //     setCount(data?.data?.total);
  //     setLoading(false);
  //   }
  // };

  const getAllStatus = async () => {
    setLoading(true);
  
    // Get today's date in a simple format
    const today = new Date().toISOString().split('T')[0];
  
    // Retrieve data from local storage
    const storedData = JSON.parse(localStorage.getItem('taskStatuses'));
    const storedDate = localStorage.getItem('loginDate');
  
    if (storedData && storedDate === today) {
      // If data exists and the date is the same, use the stored data
      setRowsPerPage(storedData.per_page);
      setTableData(storedData.data);
      setCount(storedData.total);
      setLoading(false);
    } else {
      // If date is different or data does not exist, make the API call
      try {
        const response = await AxiosAll('get', `/task-statuses?page=${page + 1}&query=${filterName}`, {}, token);
        const { data } = response;
        window.scrollTo(0, 0);
  
        if (data?.statusCode === 200) {
          // Store the API response and the current date in local storage
          localStorage.setItem('taskStatuses', JSON.stringify(data?.data));
          localStorage.setItem('loginDate', today);
  
          setRowsPerPage(data?.data?.per_page);
          setTableData(data?.data?.data);
          setCount(data?.data?.total);
        }
      } catch (error) {
        console.error("Error fetching task statuses:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  

  const getSingleStatus = async (id) => {
    const response = await AxiosAll('get', `/task-statuses/${id}`, {}, token);
    const { data } = response;

    if (data?.statusCode === 200) {
      setCurrentStatus(data?.data);
    }
  };

  useEffect(() => {
    getAllStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, filterName]);

  const handleEditRow = (id) => {
    getSingleStatus(id);
    setIsEdit(true);
    setOpen(true);
  };

  const handleConfirmDelete = () => {
    if (selected.length > 0 && multipleDeleteMode) {
      handleDeleteRows(selected);
    } else {
      handleDeleteRow(deleteId);
    }
    setDeleteDialog(false);
  };

  const closeDialog = () => {
    setOpen(false);
    if (isEdit) {
      setIsEdit(false);
      setCurrentStatus([]);
    }
  };

  const denseHeight = dense ? 52 : 72;

  const isNotFound =
    (!tableData?.length && !!filterName) ||
    (!tableData?.length && !!filterRole) ||
    (!tableData?.length && !!filterStatus);

  return (
    <Page title="Task-Status: List">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Task-Status List"
          links={[{ name: 'Dashboard', href: '/dashboard' }, { name: 'Status List' }]}
          action={
            <Button
              variant="contained"
              sx={{ mt: { xs: 2, sm: 0 } }}
              onClick={() => setOpen(true)}
              startIcon={<Iconify icon={'eva:plus-fill'} />}
            >
              New status
            </Button>
          }
        />

        <Card>
          <CreateTaskStatus
            open={open}
            onClose={closeDialog}
            currentStatus={currentStatus}
            getAllStatus={getAllStatus}
            isEdit={isEdit}
          />

          <ConfirmDialogue
            open={deleteDialog}
            loading={loading}
            onClose={() => setDeleteDialog(false)}
            onConfirm={handleConfirmDelete}
            title={`Are you sure you want to delete ${
              multipleDeleteMode && selected.length > 1 ? 'these' : 'this'
            } status?`}
            content="This action cannot be undone. Please confirm to proceed."
          />

          <TaskStatusTableToolbar
            filterName={filterName}
            filterRole={filterRole}
            onFilterName={handleFilterName}
            onFilterRole={handleFilterRole}
            search="status"
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, position: 'relative' }}>
              {selected.length > 0 && (
                <TableSelectedActions
                  dense={dense}
                  numSelected={selected.length}
                  rowCount={tableData.length}
                  onSelectAllRows={(checked) =>
                    onSelectAllRows(
                      checked,
                      tableData.map((row) => row.id)
                    )
                  }
                  actions={
                    <Tooltip title="Delete">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          setDeleteDialog(true);
                          setMultipleDeleteMode(true);
                        }}
                      >
                        <Iconify icon={'eva:trash-2-outline'} />
                      </IconButton>
                    </Tooltip>
                  }
                />
              )}

              <Table size={dense ? 'small' : 'medium'}>
                <TableHeadCustom
                  hideCheckbox
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD_COLOR}
                  rowCount={tableData.length}
                  numSelected={selected.length}
                  onSort={onSort}
                  onSelectAllRows={(checked) =>
                    onSelectAllRows(
                      checked,
                      tableData.map((row) => row.id)
                    )
                  }
                />

                {loading ? (
                  <>
                    <TableSkeleton />
                    <TableSkeleton />
                    <TableSkeleton />
                    <TableSkeleton />
                    <TableSkeleton />
                  </>
                ) : (
                  <TableBody>
                    {tableData?.map((row) => (
                      <TaskStatusTableRow
                        key={row.id}
                        row={row}
                        getItemStyle={getItemStyle}
                        setDeleteDialog={setDeleteDialog}
                        setMultipleDeleteMode={setMultipleDeleteMode}
                        setDeleteId={setDeleteId}
                        selected={selected.includes(row.id)}
                        onSelectRow={() => onSelectRow(row.id)}
                        // onDeleteRow={() => handleDeleteRow(row.id)}
                        onEditRow={() => handleEditRow(row.id)}
                      />
                    ))}

                    {/* <TableEmptyRows
                            height={denseHeight}
                            emptyRows={emptyRows(page, rowsPerPage, tableData.length)}
                          /> */}

                    <TableNoData isNotFound={isNotFound} />
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <Box sx={{ position: 'relative' }}>
            <TablePagination
              rowsPerPageOptions={[20]}
              component="div"
              count={count}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={onChangePage}
              onRowsPerPageChange={onChangeRowsPerPage}
            />

            <FormControlLabel
              control={<Switch checked={dense} onChange={onChangeDense} />}
              label="Dense"
              sx={{ px: 3, py: 1.5, top: 0, position: { md: 'absolute' } }}
            />
          </Box>
        </Card>
      </Container>
    </Page>
  );
}

// ----------------------------------------------------------------------

// function applySortFilter({ tableData, comparator, filterName, filterStatus, filterRole }) {
//   const stabilizedThis = tableData.map((el, index) => [el, index]);

//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });

//   tableData = stabilizedThis.map((el) => el[0]);

//   if (filterName) {
//     tableData = tableData.filter((item) => item.name.toLowerCase().indexOf(filterName.toLowerCase()) !== -1);
//   }

//   if (filterStatus !== 'all') {
//     tableData = tableData.filter((item) => item.status === filterStatus);
//   }

//   if (filterRole !== 'all') {
//     tableData = tableData.filter((item) => item.role === filterRole);
//   }

//   return tableData;
// }
